var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.902,
    height: 111.045,
    viewBox: "0 0 111.902 111.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-942 -116.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M561.029,2405.372q-19.005,0-38.011.012a8.19,8.19,0,0,1-5.249-1.738,7.743,7.743,0,0,1-3.107-6.02c-.009-.244-.01-.489-.01-.732q0-21.033-.01-42.065a16.318,16.318,0,0,1,2.019-8.015,15.85,15.85,0,0,1,3.367-4.242q10.033-8.956,20.077-17.9,7.263-6.479,14.512-12.975a9.946,9.946,0,0,1,4.958-2.729,7.988,7.988,0,0,1,6.92,1.856c4.575,3.989,9.077,8.062,13.609,12.1q6.367,5.676,12.733,11.354c3.149,2.811,6.328,5.59,9.431,8.452a15.749,15.749,0,0,1,5.256,11.992c.02,14.091-.019,28.183.024,42.274a8.325,8.325,0,0,1-6.635,8.258,10.111,10.111,0,0,1-1.979.112q-12.618.011-25.236.005Z",
    transform: "translate(442.633 -2191.882)",
    fill: "#ff4f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M561.029,2405.372q-19.005,0-38.011.012a8.19,8.19,0,0,1-5.249-1.738,7.743,7.743,0,0,1-3.107-6.02c-.009-.244-.01-.489-.01-.732q0-21.033-.01-42.065a16.318,16.318,0,0,1,2.019-8.015,15.85,15.85,0,0,1,3.367-4.242q10.033-8.956,20.077-17.9,7.263-6.479,14.512-12.975a9.946,9.946,0,0,1,4.958-2.729,7.988,7.988,0,0,1,6.92,1.856c4.575,3.989,9.077,8.062,13.609,12.1q6.367,5.676,12.733,11.354c3.149,2.811,6.328,5.59,9.431,8.452a15.749,15.749,0,0,1,5.256,11.992c.02,14.091-.019,28.183.024,42.274a8.325,8.325,0,0,1-6.635,8.258,10.111,10.111,0,0,1-1.979.112q-12.618.011-25.236.005Z",
    transform: "translate(446.354 -2177.4)",
    fill: "#13bbd5",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M561.029,2405.372q-19.005,0-38.011.012a8.19,8.19,0,0,1-5.249-1.738,7.743,7.743,0,0,1-3.107-6.02c-.009-.244-.01-.489-.01-.732q0-21.033-.01-42.065a16.318,16.318,0,0,1,2.019-8.015,15.85,15.85,0,0,1,3.367-4.242q10.033-8.956,20.077-17.9,7.263-6.479,14.512-12.975a9.946,9.946,0,0,1,4.958-2.729,7.988,7.988,0,0,1,6.92,1.856c4.575,3.989,9.077,8.062,13.609,12.1q6.367,5.676,12.733,11.354c3.149,2.811,6.328,5.59,9.431,8.452a15.749,15.749,0,0,1,5.256,11.992c.02,14.091-.019,28.183.024,42.274a8.325,8.325,0,0,1-6.635,8.258,10.111,10.111,0,0,1-1.979.112q-12.618.011-25.236.005Z",
    transform: "translate(427.357 -2186.006)",
    fill: "#2007fd",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M558.78,2400.692q-18.084,0-36.168.011a7.789,7.789,0,0,1-4.994-1.654,7.366,7.366,0,0,1-2.957-5.728c-.009-.232-.009-.465-.009-.7q0-20.013-.009-40.026a15.531,15.531,0,0,1,1.921-7.626,15.1,15.1,0,0,1,3.2-4.036q9.547-8.522,19.1-17.032,6.911-6.166,13.809-12.346a9.471,9.471,0,0,1,4.718-2.6,7.6,7.6,0,0,1,6.585,1.766c4.353,3.8,8.637,7.671,12.949,11.514q6.059,5.4,12.115,10.8c3,2.675,6.021,5.319,8.973,8.042a14.988,14.988,0,0,1,5,11.411c.019,13.408-.018,26.816.023,40.225a7.921,7.921,0,0,1-6.313,7.857,9.643,9.643,0,0,1-1.883.107q-12.006.01-24.012,0Z",
    transform: "translate(439.537 -2183.646)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(961.635 187.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(49.969 5.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M946.4,559.131a6.826,6.826,0,0,0,3.74,1.186c.705,0,1.069-.172,1.069-.518s-.342-.517-1.111-.582c-2.052-.065-4.531-.905-4.531-3.492,0-2.565,2.394-3.492,4.873-3.492a7.346,7.346,0,0,1,4.317,1.293l-1.667,2.371a5.674,5.674,0,0,0-2.65-.647c-.556,0-.941.13-.941.518,0,.194.15.5.791.517,2.2.065,4.852.69,4.852,3.514,0,2.63-2.373,3.622-4.916,3.622a9.318,9.318,0,0,1-5.108-1.4Z",
    transform: "translate(-945.115 -552.233)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M885.409,552.414v.687a5.643,5.643,0,1,0,0,9.556v.866h3.082V552.414Zm-.1,5.465a2.537,2.537,0,1,1-2.537-2.537A2.54,2.54,0,0,1,885.306,557.878Z",
    transform: "translate(-840.133 -546.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1013.379,552.646v.686a5.643,5.643,0,1,0,0,9.556v.865h3.082V552.646Zm-.1,5.464a2.537,2.537,0,1,1-2.537-2.537A2.54,2.54,0,0,1,1013.276,558.11Z",
    transform: "translate(-943.128 -547.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M822.3,559.153a2.513,2.513,0,0,1-2.175,1.25,2.537,2.537,0,0,1,0-5.074,2.513,2.513,0,0,1,2.175,1.25l.048.081,2.677-1.585-.048-.082a5.643,5.643,0,1,0,0,5.745l.048-.082-2.677-1.585Z",
    transform: "translate(-790.011 -546.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.178,
    cy: 2.178,
    rx: 2.178,
    ry: 2.178,
    transform: "translate(18.267)",
    fill: "#ff4f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M701.947,552.229H701.6a3.536,3.536,0,0,1-6.259,0h-.35a3.546,3.546,0,0,0-2.724,1.282v-1.1l-3.192,1.023v10.079h3.192v-6.381a1.772,1.772,0,1,1,3.544,0v6.381h3.071v-6.5a1.771,1.771,0,0,1,3.538.121v6.381h3.071v-7.742A3.546,3.546,0,0,0,701.947,552.229Z",
    transform: "translate(-689.073 -546.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M785.66,554.181V564.26h3.192v-11.1Z",
    transform: "translate(-766.81 -547.644)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.14a9d816.svg";
export { ForwardRef as ReactComponent };